<template>
  <dx-modal
    :value="show"
    @input="close"
    title="Remover Chave de API"
    size="md"
  >
    <p class="mb-2">
      Tem certeza que deseja remover esta chave de API?
    </p>
    <div class="card" v-if="apiKey">
      <div class="card-body">
        <div class="form-group">
          <label class="form-label text-bold">Chave:</label>
          <code class="key-display">{{ getMaskedKey(apiKey.apiKey) }}</code>
        </div>
        <div class="columns">
          <div class="column col-6">
            <div class="form-group">
              <label class="form-label text-bold">Throttling:</label>
              <div class="text-gray">
                {{ apiKey.throttling.requestsNumber }} requisições /
                {{ formatThrottling(apiKey.throttling.milliseconds) }}
              </div>
            </div>
          </div>
          <div class="column col-6">
            <div class="form-group">
              <label class="form-label text-bold">Rotas:</label>
              <div class="text-gray">{{ apiKey.routes.length }} rota(s) configurada(s)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toast toast-warning mt-2">
      <fa-icon :icon="['fal', 'exclamation-triangle']" class="mr-1"/>
      Esta ação não pode ser desfeita. Todas as integrações que utilizam esta chave
      deixarão de funcionar.
    </div>

    <template v-slot:footer>
      <button class="btn" @click="close" :disabled="deleting">
        Cancelar
      </button>
      <button
        class="btn btn-error ml-2"
        @click="confirmDelete"
        :disabled="deleting"
      >
        <span class="loading" v-if="deleting"></span>
        {{ deleting ? 'Removendo...' : 'Remover Chave' }}
      </button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    apiKey: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  methods: {
    getMaskedKey(apiKey) {
      if (!apiKey) return '****';
      const keyLength = apiKey.length;
      const visibleChars = 8;
      if (keyLength <= visibleChars) return apiKey;
      return `${'*'.repeat(keyLength - visibleChars)}${apiKey.slice(-visibleChars)}`;
    },
    formatThrottling(milliseconds) {
      if (milliseconds < 1000) return `${milliseconds}ms`;
      const seconds = milliseconds / 1000;
      if (seconds < 60) return `${seconds}s`;
      const minutes = Math.floor(seconds / 60);
      return `${minutes}min`;
    },
    confirmDelete() {
      if (!this.apiKey) return;

      this.deleting = true;

      this.$http.delete(`/gateway/api-keys/${this.apiKey.id}`)
        .then(() => {
          this.$toast.success('Chave de API removida com sucesso');
          this.$emit('deleted');
        })
        .catch((error) => {
          this.$toast.error(error);
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./src/assets/scss/_variables.scss";

  code {
    font-family: 'Courier New', monospace;
    background-color: $bg-color-dark;
    padding: 0.2rem 0.4rem;
    border-radius: $border-radius;
    font-size: 0.85rem;
  }

  .key-display {
    display: block;
    padding: 0.5rem;
    word-break: break-all;
  }

  .card {
    background-color: $bg-color;
    border: $border-width solid $border-color;
  }
</style>
